<template>
  <div class="ws-info-act-picker">
    <!-- {{_value}} -->
    <div
      v-for="(valueItem,valueIndex) in _value"
      :key="valueIndex"
    >
      {{valueItem}}
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    _value() {
      let _value = [];
      if (!this.originData) return;
      if (!this.originData.last_version && this.originData.article_versions === undefined && this.originData.act_version_alls === undefined) return;
      if (this.originData.article_versions || this.originData.last_version.article_versions) {
        const items = this.originData.last_version? this.originData.last_version.article_versions : this.originData.article_versions
        items.forEach((item) => {
          let newStr = "";
          if (item.act_version) {
            if (item.act_version.name) {
              newStr += `${item.act_version.name}`;
            }
            if (item.no_text) {
              newStr += ` ${item.no_text}`;
            }
          } else if (item.act_versions[0]) {
            if (item.act_versions[0].name) {
              newStr += item.act_versions[0].name;
            }
            if (item.no_text) {
              newStr += item.no_text;
            }
          }
          _value.push(newStr);
        });
      }
      if (this.originData.act_version_alls || this.originData.last_version.act_version_alls) {
        const items = this.originData.last_version? this.originData.last_version.act_version_alls : this.originData.act_version_alls
        items.forEach((item) => {
          _value.push(`${item.name}`);
        });
      }
      return _value;
    },
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    originData: {
      type: Object,
    },
    getText: {
      type: Function,
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/ws-info-act-picker.scss";
</style>